var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"default-layout"}},[_c('HeaderRetailZone'),_c('router-view'),_c('FooterRetailZone')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }